import React from "react";
import { CommonModal } from "../../AbstractElements";
import { Row, Col } from "reactstrap";
import { showAlert } from "../../Services/Shared.service";
import { deleteCar } from "../../Services/Car.service";

const DeleteConfirmationModal = ({ Large, title, LargeModaltoggle, carObj, fetchData }) => {
    const onDeleteSubmit = () => {
        deleteCar(carObj.id,carObj.isDeleted ? false : true).then(async (result) => {
           if(carObj.isDeleted) {showAlert('success', "Cab Recovered Successfully!")}
           else{showAlert('success', "Cab Deleted successfully!")}
            await fetchData()
            LargeModaltoggle();

        }).catch(err => {
            showAlert('error', err.response?.data?.message
                ? err.response.data.message : 'Something went wrong')
        })
    };
    return (
        <CommonModal
            isOpen={Large}
            title={title}
            toggler={LargeModaltoggle}
            size="md"
        >
            <Row className="driver-push-notification">
                <Col xl="12" className="push-botification-body">
                    <div className="text-center"> {carObj.isDeleted?"Are you sure you want to Recovere this car ?":"Are you sure you want to delete this car ?"}</div>
                </Col>
                <Col xl="12" className="push-notification-footer">
                    <button
                        className="btn btn-primary"
                        type="submit"
                        onClick={() => onDeleteSubmit()}
                    >
                        Confirm
                    </button>
                </Col>
            </Row>
        </CommonModal>
    );
};

export default DeleteConfirmationModal;
